export const socialFieldNames = ['Twitter', 'Instagram', 'LinkedIn', 'Facebook', 'Snapchat', 'YouTube', 'Twitch'];